class MultiSelect
  dataItemLabelKey: 'Name'
  dataItemValueKey: 'Code'
  showTitle: false

  constructor: (rootContainer, parameters = {}) ->
    if typeof rootContainer == 'string'
      rootContainer = $(rootContainer)
    if typeof rootContainer != 'object'
      console.error('rootContainer должен быть объектом [$(rootContainer)]')
      return false

    if parameters.dataItemLabelKey
      this.dataItemLabelKey = parameters.dataItemLabelKey
    if parameters.dataItemValueKey
      this.dataItemValueKey = parameters.dataItemValueKey
    if parameters.showTitle
      this.showTitle = if parameters.showTitle then true else false

    that = this
    @getRootContainer = () ->
      rootContainer

    html = new _MultiSelectHtml()
    @getHtml = () ->
      html

    data = new _MultiSelectData()
    @getData = () ->
      data

    this.getRootContainer().html(
      this.getHtml().getFrame()
    )
    this.buttonsEventHandlerRegister()

    if parameters.placeholder
      that.getFilterInput().attr("placeholder", parameters.placeholder)

    if parameters.TextSpanTotal
      that.getSpanTotal().html(parameters.TextSpanTotal)

    if parameters.TextSpanSelected
      that.getSpanSelected().html(parameters.TextSpanSelected)

    return

  getContainer = (rootContainer, needleContainer = 'left') ->
    rootContainer.find(".multiselect-#{needleContainer}-container").find('ul')

  getItemsCounterContainer = (rootContainer, needleContainer = 'left') ->
    rootContainer.find(".multiselect-#{needleContainer}-items-count")

  getItems = (container, type = 'all') ->
    switch type
      when 'selected'
        return container.find('li.multiselect-item-selected:visible')
      when 'hidden'
        return container.find('li.multiselect-item-hidden')
      when 'visible'
        return container.find('li:not(.multiselect-item-hidden)')
      when 'all'
        return container.find('li')
      else
        return []

  getItemsSelectedLeft: () ->
    getItems(
      getContainer(
        this.getRootContainer(), 'left'
      ),
      'selected'
    )

  getItemsHiddenLeft: () ->
    getItems(
      getContainer(
        this.getRootContainer(), 'left'
      ),
      'hidden'
    )

  getItemsVisibleLeft: () ->
    getItems(
      getContainer(
        this.getRootContainer(), 'left'
      ),
      'visible'
    )

  getItemsAllLeft: () ->
    getItems(
      getContainer(
        this.getRootContainer(), 'left'
      ),
      'all'
    )

  getItemsCountLeft: () ->
    this.getItemsVisibleLeft().length

  getItemsCounterLeft: () ->
    getItemsCounterContainer(
      this.getRootContainer(),
      'left'
    )

  getItemsSelectedRight: () ->
    getItems(
      getContainer(
        this.getRootContainer(), 'right'
      ),
      'selected'
    )

  getItemsHiddenRight: () ->
    getItems(
      getContainer(
        this.getRootContainer(), 'right'
      ),
      'hidden'
    )

  getItemsVisibleRight: () ->
    getItems(
      getContainer(
        this.getRootContainer(), 'right'
      ),
      'visible'
    )

  getItemsAllRight: () ->
    getItems(
      getContainer(
        this.getRootContainer(), 'right'
      ),
      'all'
    )

  getItemsCountRight: () ->
    this.getItemsVisibleRight().length

  getItemsCounterRight: () ->
    getItemsCounterContainer(
      this.getRootContainer(),
      'right'
    )

  getButtonSelectedLeftToRight: () ->
    this.getRootContainer().find('.multiselect-btn-selected2right')

  getButtonAllLeftToRight: () ->
    this.getRootContainer().find('.multiselect-btn-all2right')

  getButtonSelectedRightToLeft: () ->
    this.getRootContainer().find('.multiselect-btn-selected2left')

  getButtonAllRightToLeft: () ->
    this.getRootContainer().find('.multiselect-btn-all2left')

  getButtonDisplaySwitch: () ->
    this.getRootContainer().find('.multiselect-btn-display-switch')

  getFilterInput: () ->
    this.getRootContainer().find('.multiselect-find > input')

  getSpanTotal: () ->
    this.getRootContainer().find('.multiselect-text-total')

  getSpanSelected: () ->
    this.getRootContainer().find('.multiselect-text-selected')

  moveItems = (rootContainer, source = 'left', moveType = 'selected') ->
    destination = if source == 'left' then 'right' else 'left'
    sourceContainer = getContainer(rootContainer, source)
    destinationContainer = getContainer(rootContainer, destination)

    $.each(getItems(sourceContainer, moveType), (i, v) ->
      val = $(v).data('multiselect-item-value')
      destinationContainer.find("""li[data-multiselect-item-value="#{val}"]""")
      .removeClass('multiselect-item-hidden')
      .removeClass('multiselect-item-selected')
      $(v).addClass('multiselect-item-hidden')
      .removeClass('multiselect-item-selected')
      return
    )

    getItemsCounterContainer(rootContainer, source).html(
      getItems(sourceContainer, 'visible').length
    )
    getItemsCounterContainer(rootContainer, destination).html(
      getItems(destinationContainer, 'visible').length
    )
    return

  moveSelectedItemsLeftToRight: () ->
    moveItems(this.getRootContainer(), 'left', 'selected')

  moveAllItemsLeftToRight: () ->
    moveItems(this.getRootContainer(), 'left', 'visible')

  moveSelectedItemsRightToLeft: () ->
    moveItems(this.getRootContainer(), 'right', 'selected')

  moveAllItemsRightToLeft: () ->
    moveItems(this.getRootContainer(), 'right', 'visible')

  addItemsToLeftContainer: (items = []) ->
    container = getContainer(this.getRootContainer(), 'left')
    addedItems = new Array
    that = this
    that.getItemsAllLeft().addClass('multiselect-item-hidden')
    $.each(items, (i, v) ->
      value = eval("v.#{that.dataItemValueKey}")
      if container.find("""li[data-multiselect-item-value="#{value}"]""").length == 0
        addedItems.push(v)
      else
        container.find("""li[data-multiselect-item-value="#{value}"]""").removeClass('multiselect-item-hidden')
      return
    )

    html = this.getHtml().getItemsLeftContainer(
      this.dataItemLabelKey,
      this.dataItemValueKey,
      this.showTitle,
      addedItems
    )
    container.append(html);
    this.getItemsCounterLeft().html(
      this.getItemsVisibleLeft().length
    )
    return

  addItemsToRightContainer: (items = []) ->
    container = getContainer(this.getRootContainer(), 'right')
    addedItems = new Array
    that = this
#    that.getItemsAllRight().addClass('multiselect-item-hidden')
    $.each(items, (i, v) ->
      value = eval("v.#{that.dataItemValueKey}")
      if container.find("""li[data-multiselect-item-value="#{value}"]""").length == 0
        addedItems.push(v)
      return
    )

    html = this.getHtml().getItemsRightContainer(
      this.dataItemLabelKey,
      this.dataItemValueKey,
      this.showTitle,
      addedItems
    )
    container.append(html);
    this.getItemsCounterRight().html(
      this.getItemsVisibleRight().length
    )
    return

  normilizeItems: () ->
    leftContainer = getContainer(this.getRootContainer(), 'left')
    width = leftContainer.parent()[0].scrollWidth + 10
#    if width > 850 # см.задачу 50887
#      width = 850
    $.each(this.getItemsVisibleRight(), (i, v) ->
      value = $(v).data('multiselect-item-value')
      leftContainer.find("""li[data-multiselect-item-value="#{value}"]""")
      .addClass('multiselect-item-hidden')
      .removeClass('multiselect-item-selected')
    )
    this.getItemsAllLeft().css('width', width + 'px')
    this.getItemsAllRight().css('width', width + 'px')
    this.getItemsCounterRight().html(
      this.getItemsVisibleRight().length
    )
    this.getItemsCounterLeft().html(
      this.getItemsVisibleLeft().length
    )
    return

  display: (data = this.getData().getKendoDataSource().view())->
    this.addItemsToLeftContainer(data)
    this.addItemsToRightContainer(data)
    this.itemsEventHandlerRegister()
    this.normilizeItems()
#    this.displaySwitch2Horizontal()

    return

  displaySwitch2Vertical: () ->
    that = this
    that.getRootContainer().find('.multiselect-left-container').addClass('multiselect-container-vertical')
    that.getRootContainer().find('.multiselect-right-container').addClass('multiselect-container-vertical')
    that.getRootContainer().find('.multiselect-center-container').hide()
    that.getRootContainer().find('.multiselect-center-container-vertical').show()
    that.getButtonDisplaySwitch().attr('title', 'Переключиться в горизонтальный просмотр');
    that.getButtonDisplaySwitch().find('i').addClass('fa-arrows-h ').removeClass('fa-arrows-v').attr('title', 'Переключиться в горизонтальный просмотр');

    return

  displaySwitch2Horizontal: () ->
    that = this
    that.getRootContainer().find('.multiselect-left-container').removeClass('multiselect-container-vertical')
    that.getRootContainer().find('.multiselect-right-container').removeClass('multiselect-container-vertical')
    that.getRootContainer().find('.multiselect-center-container').show()
    that.getRootContainer().find('.multiselect-center-container-vertical').hide()
    that.getButtonDisplaySwitch().attr('title', 'Переключиться в вертикальный просмотр');
    that.getButtonDisplaySwitch().find('i').addClass('fa-arrows-v').removeClass('fa-arrows-h').attr('title', 'Переключиться в вертикальный просмотр');

    return

  displaySwitch: () ->
    that = this
    console.log('displaySwitch')
    if that.getRootContainer().find('.multiselect-container-vertical').length
      that.displaySwitch2Horizontal()
    else
      that.displaySwitch2Vertical()

    return

  # !!! EVENT HANDLERS REGISTER !!! #
  itemsEventHandlerRegister: ->
    that = this
    handlerOnClick = (event) ->
      target = $(event.target)
      parent = target.parent()
      if !event.ctrlKey
        parent.find('li').removeClass('multiselect-item-selected')
      target.toggleClass('multiselect-item-selected')
      return

    handlerOnDblClick = (event) ->
      target = $(event.target)
      container = target.parent().parent()
      if container.hasClass('multiselect-left-container')
        that.moveSelectedItemsLeftToRight()
      else
        that.moveSelectedItemsRightToLeft()
      return

    that.getItemsAllLeft().off()
    that.getItemsAllRight().off()
    that.getItemsAllLeft().on('click', handlerOnClick)
    that.getItemsAllRight().on('click', handlerOnClick)
    that.getItemsAllLeft().on('dblclick', handlerOnDblClick)
    that.getItemsAllRight().on('dblclick', handlerOnDblClick)
    return

  buttonsEventHandlerRegister: ->
    that = this
    that.getButtonAllLeftToRight().off();
    that.getButtonAllLeftToRight().on('click', () ->
      that.moveAllItemsLeftToRight()
      return
    )
    that.getButtonAllRightToLeft().off();
    that.getButtonAllRightToLeft().on('click', () ->
      that.moveAllItemsRightToLeft()
      return
    )
    that.getButtonSelectedLeftToRight().off();
    that.getButtonSelectedLeftToRight().on('click', () ->
      that.moveSelectedItemsLeftToRight()
      return
    )
    that.getButtonSelectedRightToLeft().off();
    that.getButtonSelectedRightToLeft().on('click', () ->
      that.moveSelectedItemsRightToLeft()
      return
    )
    that.getButtonDisplaySwitch().off();
    that.getButtonDisplaySwitch().on('click', () ->
      that.displaySwitch()
      return
    )

  inputFilterHandlerRegister: ->
    that = this
    that.getFilterInput().off();
    that.getFilterInput().on('keyup', (event) ->
      # отлавливаем Ctrl+A && Ctrl+C
      if(event.ctrlKey && (event.keyCode == 65 || event.keyCode == 67))
        return
      # Если вдруг нажали клавишу не алфавитную (и это не delete OR backspace OR space)
      if(event.keyCode > 0 && !String.fromCharCode(event.keyCode).match(/\w/) && (event.keyCode != 191 && event.keyCode != 220 && event.keyCode != 111 && event.keyCode != 8 && event.keyCode != 46 && event.keyCode != 32))
        return
      target = $(event.target)
      value = target.val()
#      if value.length <= 1
#        return
      that.getData().getKendoDataSource().filter({
        field: that.dataItemLabelKey,
        operator: 'contains',
        value: value
      })

      that.addItemsToLeftContainer(
        that.getData().getKendoDataSource().view()
      )
      that.normilizeItems()
      return
    )

  # VALUES #
  val: ->
    values = new Array
    $.each(this.getItemsVisibleRight(), (i, v) ->
      values.push(
        $(v).data('multiselect-item-value')
      )
    )
    values

  setValue: (value = '') ->
    that = this
    that.moveAllItemsRightToLeft()
    if value != ''
      container = getContainer(this.getRootContainer(), 'left')
      if !$.isArray(value)
        value = value.split('#')
      $.each(value, (i, v) ->
        container.find('li[data-multiselect-item-value="'+v+'"]').trigger('click')
        container.find('li[data-multiselect-item-value="'+v+'"]').trigger('dblclick')
        return
      )
    return

  clearContainer: ->
    that = this
    that.getItemsAllLeft().remove()
    that.getItemsAllRight().remove()



class _MultiSelectHtml
  # основной каркас
  getFrame: () ->
    return """
<div class="multiselect">

        <div class="multiselect-row multiselect-find">
            <input type="text" class="input_for_kendo" placeholder="Введите текст для поиска"/>
        </div>

        <div class="multiselect-row">
            <div class="multiselect-left-container">

                <ul>
                </ul>

            </div>
            <div class="multiselect-center-container">
                <button type="button" class="button-for-icon multiselect-btn-selected2right">
                  <i class="fa fa-play"></i>
                </button>
                <button type="button" class="button-for-icon multiselect-btn-selected2left">
                  <i class="fa fa-play fa-rotate-180"></i>
                </button>
                <button type="button" class="button-for-icon multiselect-btn-all2right">
                  <i class="fa fa-forward"></i>
                </button>
                <button type="button" class="button-for-icon multiselect-btn-all2left">
                  <i class="fa fa-forward fa-rotate-180"></i>
                </button>
                <button type="button" class="button-for-icon multiselect-btn-display-switch">
                  <i title="Переключиться в вертикальный просмотр" class="fa fa-arrows-v"></i>
                </button>
            </div>
            <div class="multiselect-center-container-vertical" style="display: none;">
                <button type="button" class="button-for-icon multiselect-btn-selected2right">
                  <i class="fa fa-play fa-rotate-90"></i>
                </button>
                <button type="button" class="button-for-icon multiselect-btn-selected2left">
                  <i class="fa fa-play fa-rotate-270"></i>
                </button>
                <button type="button" class="button-for-icon multiselect-btn-all2right">
                  <i class="fa fa-forward fa-rotate-90"></i>
                </button>
                <button type="button" class="button-for-icon multiselect-btn-all2left">
                  <i class="fa fa-forward fa-rotate-270"></i>
                </button>
                <button type="button" class="button-for-icon multiselect-btn-display-switch">
                  <i title="Переключиться в вертикальный просмотр" class="fa fa-arrows-v"></i>
                </button>
            </div>
            <div class="multiselect-right-container">

                <ul>
                </ul>

            </div>
        </div>

        <div class="multiselect-row">
            <div class="multiselect-left-count-rows multiselect-count-rows">
                <span><span class="multiselect-text-total">Количество записей всего</span>: <span class="multiselect-left-items-count">0</span></span>
            </div>
            <div class="multiselect-center-count-rows">
              &nbsp;
            </div>
            <div class="multiselect-right-count-rows multiselect-count-rows">
                <span><span class="multiselect-text-selected">Количество выбранных записей</span>: <span class="multiselect-right-items-count">0</span></span>
            </div>
        </div>

    </div>
"""

  # Элементы левого контейнера
  getItemsLeftContainer: (labelKey = 'Name', valueKey = 'Code', showTitle = false, data = []) ->
    cnt = '';
    $.each(data, (i, v) ->
      label = eval("v.#{labelKey}")
      value = eval("v.#{valueKey}")
      if showTitle
        sTitle = label
      else
        sTitle = ''
      cnt += """<li data-multiselect-item-value="#{value}" title="#{sTitle}">#{label}</li>"""
      return
    )
    return cnt

  # Элементы правого контейнера
  getItemsRightContainer: (labelKey = 'Name', valueKey = 'Code', showTitle = false, data = []) ->
    cnt = '';
    $.each(data, (i, v) ->
      label = eval("v.#{labelKey}")
      value = eval("v.#{valueKey}")
      if showTitle
        sTitle = label
      else
        sTitle = ''
      cnt += """<li data-multiselect-item-value="#{value}" title="#{sTitle}" class='multiselect-item-hidden'>#{label}</li>"""
      return
    )
    return cnt


class _MultiSelectData
  constructor: (kendoDataSource = new kendo.data.DataSource()) ->
    @getKendoDataSource = () ->
      kendoDataSource
    return

  sendDataToFunction: (callbackFunction) ->
    if typeof callbackFunction == 'string'
      callbackFunction = (kendoDataSource) ->
        eval(callbackFunction+'(kendoDataSource)')
        return

    that = this
    if typeof kendoDataSource.transport.data == 'undefined'
      that.getKendoDataSource().fetch(() ->
        that.getKendoDataSource().data(this.data())
        callbackFunction.call(that, that.getKendoDataSource())
      )
    else
      callbackFunction.call(that, that.getKendoDataSource())
    return

